export enum WorkspaceViewType {
   Dashboard,
   Callers,
   Callpoints,
   Schedule,
   Visits,
   Notifications
 }
